import { Helmet } from 'react-helmet-async'
import {
  PAGE_SEO,
  SITE_URL,
  DEFAULT_IMAGE,
  TWITTER_SITE,
  absoluteUrl,
  jsonLdForPath,
  pageTitle,
} from '../seo.ts'

type SeoProps = {
  title?: string
  description?: string
  path: string
  image?: string
  noindex?: boolean
  type?: 'website' | 'article'
  publishedTime?: string
  author?: string
  headline?: string
}

export default function Seo({
  title,
  description,
  path,
  image,
  noindex = false,
  type,
  publishedTime,
  author,
  headline,
}: SeoProps) {
  const page = PAGE_SEO[path]
  const resolvedTitle = title || page?.title || pageTitle('Con Man')
  const desc = description || page?.description || PAGE_SEO['/'].description
  const img = absoluteUrl(image || page?.image || DEFAULT_IMAGE)
  const url = absoluteUrl(path)
  const ogType = type || (publishedTime ? 'article' : 'website')
  const jsonLd = jsonLdForPath(path, { headline, datePublished: publishedTime, author, image: image || page?.image })

  return (
    <Helmet>
      <html lang="en-US" />
      <title>{resolvedTitle}</title>
      <meta name="description" content={desc} />
      <meta
        name="robots"
        content={
          noindex
            ? 'noindex, follow'
            : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        }
      />
      <link rel="canonical" href={url} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:site_name" content="Con Man" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      {publishedTime ? <meta property="article:published_time" content={publishedTime} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={TWITTER_SITE} />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {jsonLd.map((block, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  )
}
